export default {
  circle: 'circle',
  freehand: 'freehand',
  line: 'line',
  rectangle: 'rectangle',
  text: 'text'
}
